/* eslint-disable import/no-extraneous-dependencies */

import { GridColDef } from '@mui/x-data-grid';
import { BrowseView, browseViewColumnAction } from '@pro4-erp/core-web';
import { Edit as EditIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { StatusChip } from '@/common';
import { AuditProposal } from '../types';
import { getAuditorProposalsForMe } from '../api/getAuditorProposalsForMe';

const BrowsePage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const columns: GridColDef<AuditProposal>[] = [
    {
      ...browseViewColumnAction({
        field: 'actions',

        headerName: t('Open', { defaultValue: 'Open' }),
        icon: {
          element: <EditIcon />,
          color: 'primary',
        },
        onClick: ({ params }) => navigate(`/auditor-proposals/${params.id}`),
      }),
      display: 'flex',
    },
    {
      field: 'note',
      display: 'flex',
      headerName: t('Note', { defaultValue: 'Note' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'workExperience',
      display: 'flex',
      headerName: t('Work experience', { defaultValue: 'Work experience' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'education',
      display: 'flex',
      headerName: t('Education', { defaultValue: 'Education' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'standardRef',
      display: 'flex',
      headerName: t('Linked standard', { defaultValue: 'Linked standard' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'classRef',
      display: 'flex',
      headerName: t('Linked classification', { defaultValue: 'Linked classification' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'training',
      display: 'flex',
      headerName: t('Training', { defaultValue: 'Training' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'workplaceTraining',
      display: 'flex',
      headerName: t('Workplace training', { defaultValue: 'Workplace training' }).toString(),
      flex: 1.5,
      minWidth: 130,
      disableColumnMenu: true,
      sortable: false,
    },
    {
      field: 'status',
      display: 'flex',
      headerName: t('Status', { defaultValue: 'Status' }).toString(),
      disableColumnMenu: true,
      flex: 2,
      sortable: false,
      renderCell: (params) => {
        if (params.row.status) {
          return (
            <StatusChip
              codeId={params.row.status.codeId}
              name={params.row.status.name || ''}
              color={params.row.status.color}
            />
          );
        }
        return <>N/A</>;
      },
    },
  ];

  return (
    <BrowseView
      title={
        <BrowseView.Title>
          {t('Auditor proposals', { defaultValue: 'Auditor proposals' })}
        </BrowseView.Title>
      }
      browserViewContainerSx={{
        height: '100vh',
      }}
      columns={columns}
      fetchData={getAuditorProposalsForMe}
      toolbar={<BrowseView.Toolbar showSearch showDensityBtn />}
      onAddRowClick={() => navigate('/auditor-proposals/new')}
    />
  );
};

export default BrowsePage;
